import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetBlockedStores = (params: any) =>
    request({
        url: ApiURL.Query.GetBlockedStores,
        method: RequestType.POST,
        data: params,
    });

const StoreCargoBlockingQuery = {
    GetBlockedStores,
};

export default StoreCargoBlockingQuery;
